var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loader)?_c('Form',{attrs:{"url":"/renovacoes/config/planos-faixa/update","plano":_vm.plano}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }